import script from "./auth-status.vue?vue&type=script&lang=tsx&setup=true"
export * from "./auth-status.vue?vue&type=script&lang=tsx&setup=true"

const __exports__ = script;

export default __exports__